import { HttpErrorResponse } from '@angular/common/http';

export class ViApiError {
  code: number;
  message: string;
  original: HttpErrorResponse;
}
